$(document).ready(function () {
  let showpw = document.querySelector(".show__password");
  let inputpw = document.querySelector(".Form__Password input");

  if (showpw) {
    showpw.addEventListener("click", myFunction);
    function myFunction() {
      if (inputpw.type === "password") {
        inputpw.type = "text";
      } else {
        inputpw.type = "password";
      }
    }
  }
  $('.account-address .Address__Item.default .Segment__ActionItem[data-action="open-modal"]').click(function (event) {
    event.preventDefault();
    $(".account-address .collapse_content").slideToggle();
  });

  $('.account-address .Address__Item .Segment__ActionItem[data-action="open-modal"]').click(function (event) {
    event.preventDefault();
    let param = $(this).attr("aria-controls");
    $(`#${param}`).slideToggle();
  });
});
const scrollToElementById = (elementId, value) => {
  let element = $(`#${elementId}`);
  let position = element.offset().top;
  window.scrollTo({ top: position - value, behavior: 'smooth' });
}
